import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import blank from 'components/assets/img/pic/blank/dashboard.svg';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import { connect } from 'react-redux';

class NoResults extends Component {
  state = {
    redirect: false
  }

  setRedirect = (e) => {
    e.preventDefault();

    this.setState({
      redirect: true
    });
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      var url = TransHelper.translateRoute(this.props.locale, 'routes.url.booking');
      return <Redirect to={url} />;
    }
  }

  render() {
    return (
      <div className="content content--msg">
        <div className="content__desc">
          <div className="no-results">
            <img src={blank} alt="" className="mb-30" />
            <h3><T>content.common.nothingInfo</T></h3>
            <p className="mb-40"><T>content.common.nothingMessage</T></p>
            {this.renderRedirect()}
            <button
              className="button button--expand"
              onClick={this.setRedirect}
            >
              <T>content.common.bookNow</T>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default connect(mapStateToProps)(NoResults);
